import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import "../../css/inventory-style.css"
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import LoadingWindow from '../../components/LoadingWindow';
import { confirmCloseAlert } from '../../functions/alerts';
import { NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { getDateFromReports } from '../../functions/dateFormat';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet } from '../../functions/generateDataSetExcel';
import { Menu } from '../../components/Menu/Menu';
import '../../css/reports-v2.css';

export default class MOH extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Body: [],
        BodyFilter: [],
        flag: true
    }

    async getMOH() {
        this.ModalLoading.current.showState(true);
        const start = document.getElementById('startMOHDate').value
        const end = document.getElementById('endMOHDate').value

        if (start !== '' && end !== '') {
            const data = {
                Start: start,
                End: end
            }

            const result = await getInformationWithData('/invoice/report/MOHV2', data)

            if (result.status.code === 1) {
                result.data.forEach(item => {
                    var InvCont = Number(item.InventarioContable)
                    var Sales = Number(item.TotalSales)
                    var res = 0

                    if (Sales !== 0 && InvCont && Sales) {
                        res = InvCont / Sales
                    }

                    item.MOH = res
                    item.Validation = res < 0.5 ? 'Scare' : (res > 1 ? 'Excess' : 'Ok')
                });

                this.setState({ Body: result.data, BodyFilter: result.data })
            } else {
                this.setState({ Body: [], BodyFilter: [] })
            }

        } else {
            this.ModalLoading.current.showState(false);
            confirmCloseAlert('incorrect', 'Two dates are required for the information search')
        }
        this.ModalLoading.current.showState(false);
    }



    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

    OrderMOH(option) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "ItemCode":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "ProductLineDesc":
                temporal = OrderArray(temporal, "ProductLineDesc", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "MOH":
                temporal = OrderArray(temporal, "MOH", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    searchMOH = e => {
        const search = e.target.value;
        const Products = this.state.Body.filter(item =>
            this.contains(item.ItemCode, search) ||
            this.contains(item.ProductLineDesc, search) ||
            this.contains(item.ItemCodeDesc, search)
        );
        this.setState({ BodyFilter: Products });
    }

    getMOHKPIs() {
        const data = this.state.BodyFilter;
        if (!data.length) return null;
        const total   = data.length;
        const scarce  = data.filter(r => r.Validation === 'Scare').length;
        const ok      = data.filter(r => r.Validation === 'Ok').length;
        const excess  = data.filter(r => r.Validation === 'Excess').length;
        return { total, scarce, ok, excess };
    }

    render() {
        const hasData = this.state.Body.length > 0;
        const kpis = hasData ? this.getMOHKPIs() : null;

        return (
            <div className="rpt-page">
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* ── Page header ── */}
                <div className="rpt-page-header">
                    <h1 className="rpt-page-title">Month On Hand Report</h1>
                    <p className="rpt-page-subtitle">Compare inventory value against monthly sales to identify scarce or excess stock.</p>
                </div>

                {/* ── Controls card ── */}
                <div className="rpt-card rpt-controls">
                    <div className="row g-3 align-items-end">
                        <div className="col-sm-12 col-md-3">
                            <label className="rpt-label" htmlFor="startMOHDate">Start Date</label>
                            <input className="rpt-input" id="startMOHDate" type="date" />
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <label className="rpt-label" htmlFor="endMOHDate">End Date</label>
                            <input className="rpt-input" id="endMOHDate" type="date" />
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <button onClick={() => this.getMOH()} className="rpt-btn-primary w-100">
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                        {hasData && (
                            <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                <ExcelDocument
                                    archname={'MOH ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                    sheetname={'MOH ' + getValueCookie('Company')}
                                    data={getDataSet(this.state.Body, ['Item Code', 'Product Line', 'Description', 'MOH', 'Validation'], ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'MOH', 'Validation'])}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* ── KPI row ── */}
                {hasData && kpis && (
                    <div className="rpt-kpi-row">
                        <div className="row g-3">
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-blue">
                                    <div className="rpt-kpi-label">Total Items</div>
                                    <div className="rpt-kpi-value">{kpis.total.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">Tracked SKUs</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-red">
                                    <div className="rpt-kpi-label">Scarce</div>
                                    <div className="rpt-kpi-value">{kpis.scarce.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">MOH &lt; 0.5</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-green">
                                    <div className="rpt-kpi-label">OK</div>
                                    <div className="rpt-kpi-value">{kpis.ok.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">0.5 ≤ MOH ≤ 1</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-amber">
                                    <div className="rpt-kpi-label">Excess</div>
                                    <div className="rpt-kpi-value">{kpis.excess.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">MOH &gt; 1</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── Table card ── */}
                {hasData && (
                    <div className="rpt-card">
                        <div className="rpt-search-wrap mb-3" style={{ maxWidth: 360 }}>
                            <AiOutlineSearch />
                            <input
                                type="text"
                                autoComplete="off"
                                className="rpt-search"
                                placeholder="Search by item code, line, description…"
                                onChange={this.searchMOH}
                            />
                        </div>
                        <div className="rpt-table-wrapper">
                            <table className="rpt-table">
                                <thead>
                                    <tr className="table-blue-header">
                                        <th onClick={() => this.OrderMOH("ItemCode")}>
                                            Item Code <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>
                                        </th>
                                        <th onClick={() => this.OrderMOH("ProductLineDesc")}>
                                            Product Line <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>
                                        </th>
                                        <th>Description</th>
                                        <th>Inventory Value</th>
                                        <th>Month Sales</th>
                                        <th onClick={() => this.OrderMOH("MOH")}>
                                            MOH <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>
                                        </th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.BodyFilter.map((element, e) => (
                                        <tr key={e}>
                                            <td>{element.ItemCode}</td>
                                            <td>{element.ProductLineDesc}</td>
                                            <td>{element.ItemCodeDesc}</td>
                                            <td className="text-end">{element.InventarioContable}</td>
                                            <td className="text-end">{element.TotalSales}</td>
                                            <td className="text-center">{NumberFormat(pricesFormat(element.MOH))}</td>
                                            <td className="text-center">
                                                <span style={{
                                                    display: 'inline-block',
                                                    padding: '2px 10px',
                                                    borderRadius: 20,
                                                    fontSize: '0.75rem',
                                                    fontWeight: 600,
                                                    background: element.Validation === 'Scare' ? 'var(--rpt-red-light)' : element.Validation === 'Excess' ? 'var(--rpt-amber-light)' : 'var(--rpt-green-light)',
                                                    color: element.Validation === 'Scare' ? 'var(--rpt-red)' : element.Validation === 'Excess' ? 'var(--rpt-amber)' : 'var(--rpt-green)',
                                                }}>
                                                    {element.Validation}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* ── Empty state ── */}
                {!hasData && (
                    <div className="rpt-empty">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                        </svg>
                        <p>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                    </div>
                )}
            </div>
        )
    }
}
